import { render } from "./CoursesPage.vue?vue&type=template&id=86c315ea"
import script from "./CoursesPage.vue?vue&type=script&lang=js"
export * from "./CoursesPage.vue?vue&type=script&lang=js"

import "./CoursesPage.vue?vue&type=style&index=0&id=86c315ea&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__